import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/__auth/profile")({
    component: ProfileLayout,
});

function ProfileLayout() {
    return <Outlet />;
}
